import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-sitekey", "id"]

import { onMounted } from 'vue';

/* eslint-disable */

export default /*#__PURE__*/_defineComponent({
  __name: 'TurnstileCaptcha',
  props: {
  sitekey: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



function executeWhenTurnstileLoads(cb: () => void) {
  console.log('Loading Turnstile')
  // @ts-ignore
  if (typeof window.turnstile === 'object') {
    console.log('Turnstile loaded')
    cb();
  } else {
    setTimeout(() => {
      executeWhenTurnstileLoads(cb);
    }, 1000);
  }
}

onMounted(() => {
  executeWhenTurnstileLoads(() => {
    // @ts-ignore
    window.turnstile.render(`#${props.id}-turnstile`, {
      sitekey: props.sitekey,
    });
  });
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-sitekey": __props.sitekey,
    id: `${__props.id}-turnstile`
  }, null, 8, _hoisted_1))
}
}

})